/**
 * AMC DC — How it works: fill slides L→R, pauses at each dot; active step copy lifts.
 */
(function () {
  var MOVE_MS = 1600;
  var HOLD_MS = 1800;

  function boot(root) {
    if (!root || root.getAttribute('data-amc-dc-how-ready')) return;
    root.setAttribute('data-amc-dc-how-ready', '1');

    var fill = root.querySelector('[data-amc-dc-how-fill]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.amc-dc-how__step'));
    if (!steps.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var i = 0;

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function widthFor(idx) {
      if (steps.length <= 1) return 100;
      return (idx / (steps.length - 1)) * 100;
    }

    function activate(idx) {
      steps.forEach(function (el, n) {
        el.classList.toggle('is-active', n === idx);
        el.classList.toggle('is-passed', n < idx);
      });
    }

    function setFill(pct, instant) {
      if (!fill) return;
      fill.style.transition = instant ? 'none' : 'width ' + MOVE_MS + 'ms ease-in-out';
      fill.style.width = pct + '%';
    }

    function clearStates() {
      steps.forEach(function (el) {
        el.classList.remove('is-active', 'is-passed');
      });
    }

    function holdThenAdvance() {
      activate(i);
      timer = window.setTimeout(function () {
        if (i >= steps.length - 1) {
          timer = window.setTimeout(function () {
            setFill(0, true);
            clearStates();
            if (fill) void fill.offsetWidth;
            i = 0;
            timer = window.setTimeout(holdThenAdvance, 80);
          }, 280);
          return;
        }
        i += 1;
        setFill(widthFor(i), false);
        timer = window.setTimeout(holdThenAdvance, MOVE_MS);
      }, HOLD_MS);
    }

    function start() {
      root.classList.add('is-animating');
      if (reduced) {
        activate(0);
        setFill(100, true);
        return;
      }
      i = 0;
      setFill(0, true);
      holdThenAdvance();
    }

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }

    var seen = false;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !seen) {
            seen = true;
            start();
            io.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    io.observe(root);

    root.addEventListener(
      'amc-dc-how-stop',
      function () {
        clearTimer();
      },
      { once: true }
    );
  }

  function scan() {
    document.querySelectorAll('.amc-dc-how').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
